import { render, staticRenderFns } from "./VPageTitle.vue?vue&type=template&id=85413de6&"
import script from "./VPageTitle.vue?vue&type=script&lang=ts&"
export * from "./VPageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./VPageTitle.vue?vue&type=style&index=0&id=85413de6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports